export const timing = {
  fast: '.1s',
  main: '.2s',
  slow: '.4s',
}

export const easing = {
  main: 'ease-in',
  in: 'ease-in',
  out: 'ease-out',
  cubicBezier: 'cubic-bezier(.71, .31, .52, .95)',
}

export const transition = {
  fast: `all ${timing.fast} ${easing.main}`,
  main: `all ${timing.main} ${easing.main}`,
  slow: `all ${timing.slow} ${easing.main}`,
}

export const keyframes = [
  `@keyframes bouncing {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }`,
  `@keyframes wave {
    from { left: -200%; }
    to { left: 200%; }
  }`,
  `@keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }`,
  `@keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }`,
  `@keyframes sidenav-collapsed {
    0% {
      width: 100%;
      opacity: 1;
    }
    50% {
      width: 100%;
      opacity: 0;
    }
    100% {
      width: 0;
      opacity: 0;
    }
  }`,
  `@keyframes sidenav-open {
    0% {
      width: 0;
      opacity: 0;
    }
    50% {
      width: 100%;
      opacity: 0;
    }
    100% {
      width: 100%;
      opacity: 1;
    }
  }`,
  `@keyframes slide-wipe {
    100% { clip-path: polygon(0 0, 0 0, -25% 100%, 0 100%); }
  }`,
  `@keyframes fade-in-content {
    0%: { opacity: 0; }
    100%: { opacity: 1; }
  }`,
  `@keyframes bounce-1 {
    0% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
    100% { transform: translateY(0); }
  }`,
  `@keyframes bounce-2 {
    0% { transform: translateY(0); margin-top: 0px; }
    12.5% { margin-top: -4px; }
    25% { transform: translateY(4px); }
    37.5% { margin-top: 0; }
    50% { transform: translateY(0); }
    75% { transform: translateY(4px); }
    100% { transform: translateY(0); }
  }`,
  `@keyframes bounce-3 {
    0% { transform: translateY(0); }
    12.5% { transform: translateY(4px); }
    25% { transform: translateY(0); }
    37.5% { transform: translateY(4px); }
    50% { transform: translateY(0); }
    62.5% { transform: translateY(4px); }
    75% { transform: translateY(0); }
    87.5% { transform: translateY(4px); }
    100% { transform: translateY(0); }
  }`,
]

const state = {
  hide: {
    opacity: 0,
    visibility: 'hidden',
    pointerEvents: 'none',
  },
  show: {
    opacity: 1,
    visibility: 'visible',
    pointerEvents: 'all',
  },
  timing,
  easing,
  transition,
}

export default state
